/**
* Card Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'card-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.card-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--card-slider' )[0], {
          pagination: false,
          arrows: true,
        } );

        splide.mount();

        $( component ).find( '.slider-nav .slide' ).on( 'click', function() {
          // console.log( $( this ).attr( 'data-slide' ) );
          splide.go( parseInt( $( this ).attr( 'data-slide' ) ) );
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-slider', COMPONENT );
} )( app );
